module.exports = MaterialUI.createMuiTheme;